<template>
  <div class="side-rank">
    <template v-if="!giftingEnabled">
      <UiEmpty layout="column"></UiEmpty>
    </template>
    <template v-else>
      <div class="side-rank-title">
        <i></i>
        本局比赛战队赠礼排行
      </div>
      <div class="side-rank-center">
        <FanTopThree class="top-three-box" :items="fanListTop3" :default-avatar="defaultUrl" size="xs" />
        <div class="fan-rank">
          <div
            class="list-item"
            v-show="filteredList.length > 0"
            v-for="(item, index) in filteredList"
            :key="index"
          >
            <div class="first">
              <div class="label-box">
                <span class="label-shadow">{{ index + 4 }}</span>
                <span class="label-text">{{ index + 4 }}</span>
              </div>
            </div>
            <div class="nanu">
              <div
                class="avatar"
                :style="{
                  'background-image': `url(${item.avatarUrl || defaultUrl})`
                }"
              >
              </div>
              <div class="name">
                {{ item.nickName }}
              </div>
            </div>
            <div class="hot">
              {{countShow( item.popularity)}}
            </div>
          </div>

          <!-- <div class="fan-cneter"></div> -->
        </div>
        <UiButton class="side-rank-bottom" @click="linkTo('Ranking')">
          <i></i>
          <div class="label-box">
            <span class="label-shadow">赠礼排行榜</span>
            <span class="label-text">赠礼排行榜</span>
          </div>
        </UiButton>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore, useStageStore } from '@/store'
import * as api from '@/service/index'
import UiEmpty from '@/components/ui-empty'
import UiButton from '@/components/ui-button'
import FanTopThree from '@/views/ranking/fan-top-three.vue'

defineProps({
  // fanList: Array,
  rankType: String
})

const router = useRouter()

const appStore = useAppStore()
const stageStore = useStageStore()

const fanList = ref([])
const defaultUrl = ref('https://website.xdcdn.net/form/match/avatar/Portrait1.png')
const hasLoadedFanList = ref(false)

const token = computed(() => appStore.token)
const giftingEnabled = computed(() => stageStore.giftingEnabled)
const fanListTop3 = computed(() => {
  return fanList.value?.filter((item, index) => index <= 2)
})
const filteredList = computed(() => {
  return fanList.value?.filter((item, index) => index > 2)
})

function initFanList() {
  if (hasLoadedFanList.value || !giftingEnabled.value || !token.value) return
  hasLoadedFanList.value = true
  livePersonalRanking()
}
async function livePersonalRanking() {
  try {
    if(!token.value) return;
    let { status, data } = await api.getPersonalRanking(token.value)
    if (status === 200) {
      const list = data.totalList || []
      // 数据层兜底: 不足 3 项时补占位, 保证 top3 卡壳始终 3 张 (对齐 ranking/index.vue + teams/detail/fan.vue)
      while (list.length < 3) {
        list.push({ avatarUrl: '', nickName: '-', popularity: 0 })
      }
      fanList.value = list
    }
  } catch (err) {
    console.log(err)
  }
}
function linkTo(name) {
  router.push({
    name: name
  })
}
function countShow(hot){
  if(hot){
    if(hot<10000){
      return hot
    }else if(10000 <= hot && hot < 99999999){
      return (((hot / 10000)* 100) /100).toFixed(2) + '万'
    }else {
      return  9999 +'万+'
    }
  }else{
    return  0
  }
}

watch(
  token,
  () => {
    initFanList()
  },
  { immediate: true }
)
watch(
  giftingEnabled,
  () => {
    initFanList()
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.side-rank{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .side-rank-title{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    @include r(height, 38);
    @include r(font-size, 18);
    color: #333333;
    i {
      display: inline-block;
      @include r(width, 21);
      @include r(height, 24);
      background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/Q08sFuxg.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      @include r(margin-right, 5);
    }
  }
  .side-rank-center{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1;
    overflow: hidden;
    .top-three-box {
      @include r(width, 297);
      @include r(height, 95);
      @include r(margin-bottom, 10);
    }
    .fan-rank {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      overflow-y: scroll;
      flex: 1;
      @include showScrollBar();
      .list-item {
        position: relative;
        // 不加 isolation: 让 &::before 的 z-index: -1 穿到父级 .side-content 的 stacking context 底,
        // 参与和 side-content ::before (粉红背景层) 的 multiply 混合
        display: flex;
        color: #333;
        align-items: center;
        flex-shrink: 0;
        @include r(height, 56);

        // 偶数行斑马纹: #FFD3D3 走 multiply 混合模式, 拆到 ::before 避免影响子级文字/图片
        &:nth-child(even)::before {
          content: '';
          position: absolute;
          inset: 0;
          background-color: #FFD3D3;
          mix-blend-mode: multiply;
          pointer-events: none;
          z-index: -1;
        }
        .first {
          flex: 16%;
          @include r(font-size, 30);
          font-weight: bold;
          font-family: NumFont;
          .label-box {
            .label-shadow {
              color: #FFFFFF;
            }
            .label-text {
              color: #333333;
            }
          }
        }

        .nanu{
          flex: 60%;
          display: flex;
          flex-direction: row;
          justify-content: left;
          align-items: center;

          .avatar {
            @include r(width, 38);
            @include r(height, 38);
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            border-style: solid;
            border-color: #DDD;
            @include r(border-width, 2);
            @include r(border-radius, 4);
            @include r(margin-right, 8);
          }
          .name {
            @include r(font-size, 16);
            text-align: left;
          }
        }
        .hot {
          @include r(font-size, 16);
          flex: 24%;
          text-align: center;
          color: #666;
        }
      }

    }
    .side-rank-bottom{
      text-align: center;
      background: url(https://website.xdcdn.net/poster/58881/26match/common/Q3v2R7kg.png) center/100% 100% no-repeat;
      @include r(width, 306);
      @include r(height, 44);
      @include r(font-size, 20);
      @include r(margin, 8, 0, 6);
      @include r_shadow(0, 4, 4, #{rgba(#000, 0.25)});
      i {
        position: absolute;
        @include r(left, 72);
        @include r(width, 22);
        @include r(height, 23);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        display: flex;
        background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/Q3vhBr6i.png);
        @include r(margin-right, 7);
      }
    }
  }
}
</style>
